import React, { Component } from "react";
import cx from "classnames";

import { post } from "../../utils/apiHandler.js";
import tracking from "../../utils/tracking";

export default class Zusammenfassung extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(e) {
    e.preventDefault();

    let data = {
      id: 2,
      contact: this.props.contactData,
      reservation: this.props.reservationData,
    };
    post("/appointments/drweyrich", data).then((resp) => {
      if (resp.success) {
        tracking.event("summary", "submit", "success", 5);
        this.props.onNext();
      } else {
        tracking.event("summary", "submit", "failed");
        window.location.replace("/");
      }
    });
  }

  render() {
    let classes = cx("zusammenfassung", "content", {
      hidden: !this.props.active,
    });
    return (
      <div>
        <div id="errorApi" className="error">
          Cher client, malheureusement, contactez le cabinet.
        </div>
        <section className={classes}>
          <div className="row">
            <div className="col-md-6 lead">
              Contact informations
              <hr />
            </div>
            <div className="col-md-6 lead">
              Reservation informations
              <hr />
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <span className="text-muted">Email:</span>{" "}
              {this.props.contactData.email || ""}
              <br />
              <span className="text-muted">Nom:</span>{" "}
              {this.props.contactData.name || ""}{" "}
              {this.props.contactData.surname || ""}
              <br />
              <span className="text-muted">Adress:</span>{" "}
              {this.props.contactData.adress || ""}
              <br />
              <span className="text-muted">Code postal:</span>{" "}
              {this.props.contactData.zip || ""}
              <br />
              <span className="text-muted">Ville:</span>{" "}
              {this.props.contactData.city || ""}
              <br />
              <span className="text-muted">Téléphone:</span>{" "}
              {this.props.contactData.phone || ""}
              <br />
              <span className="text-muted">Matricule:</span>{" "}
              {this.props.contactData.svn || ""}
              <br />
            </div>
            <div className="col-md-6">
              <span className="text-muted">Date:</span>{" "}
              {this.props.reservationData.date || ""}
              <br />
              <span className="text-muted">Time:</span>{" "}
              {this.props.reservationData.time || ""}
              <br />
            </div>
          </div>
          <div className="clearfix"></div>
          <br />
          <button onClick={this.props.onPrev} className="btn btn-default">
            Back
          </button>
          <button
            onClick={this.handleSubmit}
            className="btn btn-default pull-right"
          >
            Envoyer
          </button>
        </section>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/module/zusammenfassung/index.js